import { useMutation } from "react-query";

import { applicationListService } from "services";

type UseMutationProps = {
	appId: string | number;
	documentId: string | number;
};

const useCopyMpaDocumentMutation = () => {
	return useMutation(({ appId, documentId }: UseMutationProps) =>
		applicationListService.copyMpaDocument(appId, documentId),
	);
};

export default useCopyMpaDocumentMutation;
